import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weightFormat',
  standalone: true
})
export class WeightFormatPipe implements PipeTransform {

  transform(value: number, unit: string = 'Lbs'): string {
    return `${value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} ${unit}`;
  }

}
